module.exports = __webpack_public_path__ + "static/media/persona-border.04a3e475.svg";